<template>
  <FadeTransition v-show="show" :duration="200">
    <div class="info-bar-modal">
      <div
        :class="{
          bar_box: true,
          bg_white: color == 'white',
          bg_black: color == 'black',
          bg_blue: color == 'blue',
          bg_red: color == 'red',
          bg_green: color == 'green',
          bg_yellow: color == 'yellow',
        }"
      >
        <span class="d-block mb-0 mr-2">{{ text }}</span>
        <span class="fas fa-times-circle" @click="$emit('close')"></span>
      </div>
    </div>
  </FadeTransition>
</template>

<script>
import { FadeTransition } from 'vue2-transitions';

export default {
  props: {
    text: {
      type: String,
      default: () => 'Escribe el mensaje aquí'
    },
    color: {
      type: String,
      default: () => 'white'
    },
    show: {
      type: Boolean,
      default: () => false
    }
  },
  components: {
    FadeTransition
  }
}
</script>

<style scoped>
.info-bar-modal {
  position: absolute;
  top: 1rem;
  left: 0;
  right: 0;
  z-index: 301;
}
.info-bar-modal .bar_box {
  display: flex;
  align-items: center;
  justify-content: center;
  /* background-color: #181818; */
  border-radius: 1rem;
  min-width: 700px;
  width: fit-content;
  height: 50px;
  padding: 0 1rem;
  margin: 0 auto;
  color: #fff;
  box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.25);
}
.info-bar-modal .bar_box span {
  color: #fff;
}
.info-bar-modal .bar_box.bg_white {
  background-color: #fff;
  box-shadow: 10px 10px 30px #DEEDFF;
}
.info-bar-modal .bar_box.bg_white span {
  color: #767676;
}
.info-bar-modal .bar_box.bg_black {
  background-color: #181818;
}
.info-bar-modal .bar_box.bg_blue {
  background-color: #2981EF;
}
.info-bar-modal .bar_box.bg_green {
  background-color: #34a82f;
}
.info-bar-modal .bar_box.bg_yellow {
  background-color: #e4ac07;
}
.info-bar-modal .bar_box.bg_red {
  background-color: #ff3860;
}
</style>